import { render, staticRenderFns } from "./Pods.vue?vue&type=template&id=1851d9e8&scoped=true&"
import script from "./Pods.vue?vue&type=script&lang=js&"
export * from "./Pods.vue?vue&type=script&lang=js&"
import style0 from "./Pods.vue?vue&type=style&index=0&id=1851d9e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1851d9e8",
  null
  
)

export default component.exports